import { CheckCircleOutline, Close, Delete, Description, InfoOutlined, Upload, Visibility } from "@mui/icons-material";
import {
  Alert,
  Autocomplete,
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import LoadingIcon from "src/Components/Common/LoadingIcon";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";
import CustomToast from "src/Components/CustomToast";
import { AttachmentType, DepartmentType, DocType, VendorDisputeStatusEnumDR } from "./constants/disputeEntries";

import dayjs from "dayjs";
import useFetch from "src/Components/Common/useFetch";
import { userContext } from "src/Components/Contexts/userContext";
import { UserRole } from "src/entity/models/FrontendActor";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";

const TakeActionDisputedEntries = ({
  selectedRowOfDisputedEntryForModal,
  openTakeActionModal,
  setOpenTakeActionModal,
  selectedRowIndex,
  disputedEntriesData,
  setDisputedEntriesData,
  setSummaryData,
  generateSummaryFromData,
  departmentName,
  allUsers,
  role,
}) => {
  const { actor } = useContext(userContext);
  const [fileInput, setFileInput] = useState<HTMLInputElement | null>(null);
  const [fileInputPod, setFileInputPod] = useState<HTMLInputElement | null>(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [podUploadedFiles, setPodUploadedFiles] = useState([]);

  // Individual form state variables
  const [vendorRemarks, setVendorRemarks] = useState("");
  // const [instamartRemarks, setInstamartRemarks] = useState('');
  const [gapReason, setGapReason] = useState(selectedRowOfDisputedEntryForModal?.gapReason || "");
  const [arBtplRemark, setArBtplRemark] = useState("");
  const [categoryRemark, setCategoryRemark] = useState("");
  const [procurementRemark, setProcurementRemark] = useState("");
  const [warehouseRemarks, setWarehouseRemarks] = useState("");
  const [financeRemarks, setFinanceRemarks] = useState("");
  const [dependency, setDependency] = useState(selectedRowOfDisputedEntryForModal?.dependency || "");
  const [action, setAction] = useState(selectedRowOfDisputedEntryForModal?.action || "");
  const [resolutionStatus, setResolutionStatus] = useState(selectedRowOfDisputedEntryForModal?.resolutionStatus || "");
  const [gapReasonOptions, setGapReasonOptions] = useState([]);
  const [actionOptions, setActionOptions] = useState([]);
  const [allActionOptions, setAllActionOptions] = useState([]);

  const [attachments, setAttachments] = useState([]);
  const [attachmentsPOD, setAttachmentsPOD] = useState([]);
  const [currentMaker, setCurrentMaker] = useState([]);
  const [currentChecker, setCurrentChecker] = useState([]);
  const [currentApprover, setCurrentApprover] = useState([]);
  const [currentPriority, setCurrentPriority] = useState(selectedRowOfDisputedEntryForModal?.priority || "");
  const [currentDueDate, setCurrentDueDate] = useState(
    selectedRowOfDisputedEntryForModal?.dueDate
      ? dayjs(selectedRowOfDisputedEntryForModal.dueDate).format("YYYY-MM-DD")
      : ""
  );
  const [grnNumber, setGrnNumber] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [openResolveDisputeModal, setOpenResolveDisputeModal] = useState(false);
  const [loaderResolveDispute, setLoaderResolveDispute] = useState(false);

  const [oldValues, setOldValues] = useState({
    vendorRemarks: "",
    financeRemarks: "",
    warehouseRemarks: "",
    procurementRemarks: "",
    arBtplRemarks: "",
    categoryRemarks: "",
    gapValueId: null,
    gapReason: "",
    action: "",
    dependency: "",
    resolutionStatus: selectedRowOfDisputedEntryForModal?.resolutionStatus || "",
    priority: "",
    dueDate: "",
    approver: [],
    checker: [],
    maker: [],
    grnNumber: "",
    poNumber: "",
    invoiceNumber: "",
  });

  // Create a boolean variable for the condition
  const shouldShowGrnFields =
    selectedRowOfDisputedEntryForModal?.docType === DocType.Invoice &&
    (selectedRowOfDisputedEntryForModal?.reconStatus === "Invoice not present in Partner Ledger" ||
      selectedRowOfDisputedEntryForModal?.reconStatus === "Invoice not present in Own Ledger" ||
      selectedRowOfDisputedEntryForModal?.reconStatus === "Invoice - Mismatched Entry - Others");
  const handleClose = () => {
    setOpenTakeActionModal(false);
    // remove this later
    setGapReasonOptions([]);
  };

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalFiles = uploadedFiles.length + selectedFiles.length;

    if (totalFiles > 5) {
      toast.error(<CustomToast message="You can only upload up to 5 files." />);
      event.target.value = ""; // Clear input so same files can be re-selected
      return;
    }

    setUploadedFiles((prev) => [...selectedFiles, ...prev]);
    event.target.value = "";
  };

  const handlePODFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalFiles = podUploadedFiles.length + selectedFiles.length;

    if (totalFiles > 5) {
      toast.error(<CustomToast message="You can only upload up to 5 files." />);
      event.target.value = ""; // Clear input so same files can be re-selected
      return;
    }

    setPodUploadedFiles((prev) => [...selectedFiles, ...prev]);
    event.target.value = "";
  };

  const handleDelete = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const handleDeletePOD = (index) => {
    setPodUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleViewAttachment = (file) => {
    useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_ACTIONS_ATTACHMENTS_VIEW.url, "POST", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_ACTIONS_ATTACHMENTS_VIEW.failureMessage,
      config: {
        params: {
          gapId: selectedRowOfDisputedEntryForModal.gapId,
          attachmentId: file.id,
        },
      },
      thenCallBack: (_res) => {
        const link = document.createElement("a");
        link.href = _res.data.data;
        link.target = "_blank";
        link.referrerPolicy = "no-referrer";
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // window.open(_res.data.attachment, "_blank", "noopener,noreferrer");
      },
    });
  };

  const handleGapReasonOption = (e) => {
    const selectedGapReason = e.target.value;
    setGapReason(selectedGapReason);

    const actionOptionValues =
      Array.from(
        new Set(allActionOptions.filter((item) => item.gapReason === selectedGapReason).map((item) => item.action))
      ) || [];

    setActionOptions(actionOptionValues);

    const selectedAction = actionOptionValues[0] || "";
    setAction(selectedAction);

    // Fetch dependency and resolutionStatus based on selected gap reason
    const matchingEntry = allActionOptions.find(
      (entry) => entry.action === selectedAction && entry.gapReason === selectedGapReason
    );

    if (matchingEntry) {
      setDependency(matchingEntry.dependency);
      setResolutionStatus(matchingEntry.resolutionStatus);
    } else {
      setDependency("");
      setResolutionStatus("");
    }
  };

  const handleActionOption = (e) => {
    const selectedAction = e.target.value;
    setAction(selectedAction);

    const matchingEntry = allActionOptions.find(
      (entry) => entry.action === selectedAction && entry.gapReason === gapReason
    );

    if (matchingEntry) {
      setDependency(matchingEntry.dependency);
      setResolutionStatus(matchingEntry.resolutionStatus);
    } else {
      setDependency("");
      setResolutionStatus("");
    }
  };

  // api integration--------------

  useEffect(() => {
    getTakeActionDataActionsOptions();
    getTakeActionDataActionAttachments(selectedRowOfDisputedEntryForModal?.gapId);
    getTakeActionDataRemarks(selectedRowOfDisputedEntryForModal?.gapId);
    getTakeActionDataActionOwner(selectedRowOfDisputedEntryForModal?.gapId);
    getTakeActionDataActionViewInfo(selectedRowOfDisputedEntryForModal?.gapId);
  }, []);

  const getTakeActionDataActionAttachments = async (gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_ACTION_ATTACHMENTS(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_ACTION_ATTACHMENTS(gapId).failureMessage,
      thenCallBack: (response) => {
        const allAttachments = response.data.data || [];

        // Separate attachments based on AttachmentType
        const podAttachments = allAttachments.filter((attachment) => attachment.attachmentType === AttachmentType.POD);
        const otherAttachments = allAttachments.filter(
          (attachment) => attachment.attachmentType === AttachmentType.Others
        );

        setAttachmentsPOD(podAttachments);
        setAttachments(otherAttachments);
      },
      catchCallBack: () => {},
    });
  };

  const getTakeActionDataRemarks = async (gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_REMARK(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_REMARK(gapId).failureMessage,
      thenCallBack: (response) => {
        response.data?.data.forEach((item) => {
          if (item.department === "Vendor") {
            setVendorRemarks(item.remark);
            setOldValues((prev) => ({ ...prev, vendorRemarks: item.remark }));
          } else if (item.department === "Finance") {
            setFinanceRemarks(item.remark);
            setOldValues((prev) => ({ ...prev, financeRemarks: item.remark }));
          } else if (item.department === "Procurement") {
            setProcurementRemark(item.remark);
            setOldValues((prev) => ({ ...prev, procurementRemarks: item.remark }));
          } else if (item.department === "Warehouse") {
            setWarehouseRemarks(item.remark);
            setOldValues((prev) => ({ ...prev, warehouseRemarks: item.remark }));
          } else if (item.department === "AR/BTPL") {
            setArBtplRemark(item.remark);
            setOldValues((prev) => ({ ...prev, arBtplRemarks: item.remark }));
          } else if (item.department === "Category") {
            setCategoryRemark(item.remark);
            setOldValues((prev) => ({ ...prev, categoryRemarks: item.remark }));
          }
        });
      },
      catchCallBack: () => {},
    });
  };
  const getTakeActionDataActionOwner = async (gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_ACTION_OWNERS(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_ACTION_OWNERS(gapId).failureMessage,
      thenCallBack: (response) => {
        setCurrentMaker(response.data.data.maker || []);
        setCurrentChecker(response.data.data.checker || []);
        setCurrentApprover(response.data.data.approver || []);

        setOldValues((prev) => ({
          ...prev,
          maker: response.data.data.maker || [],
          checker: response.data.data.checker || [],
          approver: response.data.data.approver || [],
        }));
      },
      catchCallBack: () => {},
    });
  };
  const getTakeActionDataActionsOptions = async () => {
    await useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_ACTIONS_OPTIONS.url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_ACTIONS_OPTIONS.failureMessage,
      config: {
        params: {
          documentType: selectedRowOfDisputedEntryForModal?.docType || "",
          reconStatus: selectedRowOfDisputedEntryForModal?.reconStatus || "",
        },
      },
      thenCallBack: (response) => {
        setAllActionOptions(response.data?.data || []);
        // unique gap reasons
        setGapReasonOptions(Array.from(new Set(response.data?.data.map((item) => item.gapReason))) || []);

        // unique actions (based on selected gapReason)
        setActionOptions(
          Array.from(
            new Set(
              response.data?.data
                .filter((item) => item.gapReason === selectedRowOfDisputedEntryForModal?.gapReason)
                .map((item) => item.action)
            )
          ) || []
        );
      },
      catchCallBack: () => {},
    });
  };
  const getTakeActionDataActionViewInfo = async (gapId) => {
    await useFetch(API_ENDPOINTS.FETCH_DR_ENTRIES_VIEW_INFO(gapId).url, "GET", {
      failureMessage: API_ENDPOINTS.FETCH_DR_ENTRIES_VIEW_INFO(gapId).failureMessage,
      thenCallBack: (response) => {
        // setActionOptions(allActionOptions.filter((item) => item.gapReason === response.data?.gapReason).map((item) => item.action) || []);
        //            setGapReason(response.data.data?.gapReason);
        // setAction(response.data.data?.action);
        // setDependency(response.data.data?.dependency);
        // setCurrentPriority(response.data.data?.priority);
        // setCurrentDueDate(response.data.data?.dueDate);
        // setResolutionStatus(response.data?.resolutionStatus);

        setGrnNumber(response.data?.data?.grnNumber || "");
        setPoNumber(response.data?.data?.poNumber || "");
        setInvoiceNumber(response.data?.data?.invoiceNumber || "");

        setOldValues((prev) => ({
          ...prev,
          gapValueId: response.data?.data?.gapValueId || null,
          gapReason: response.data?.data?.gapReason || "",
          action: response.data?.data?.action || "",
          dependency: response.data?.data?.dependency || "",
          priority: response.data?.data?.priority || "",
          dueDate: dayjs(response.data?.data?.dueDate).format("YYYY-MM-DD") || "",
          grnNumber: response.data?.data?.grnNumber || "",
          poNumber: response.data?.data?.poNumber || "",
          invoiceNumber: response.data?.data?.invoiceNumber || "",
        }));
      },
      catchCallBack: () => {},
    });
  };

  const handleSubmit = () => {
    setIsLoadingSubmit(true);
    updateTakeActionDataAction(selectedRowOfDisputedEntryForModal?.gapId);
  };

  const updateTakeActionDataAction = async (gapId) => {
    const newValuesData = {
      vendorRemarks: vendorRemarks,
      financeRemarks: financeRemarks,
      warehouseRemarks: warehouseRemarks,
      procurementRemarks: procurementRemark,
      arBtplRemarks: arBtplRemark,
      categoryRemarks: categoryRemark,
      gapValueId: allActionOptions.find((item) => item.gapReason === gapReason && item.action === action)?.id || null,
      gapReason: gapReason,
      action: action,
      dependency: dependency,
      resolutionStatus: resolutionStatus,
      priority: currentPriority,
      dueDate: currentDueDate,
      approver: currentApprover,
      checker: currentChecker,
      maker: currentMaker,
      grnNumber: grnNumber,
      poNumber: poNumber,
      invoiceNumber: invoiceNumber,
    };
    const bodyFormData = new FormData();

    // Add regular files with "Others" attachment type
    for (const item of uploadedFiles) {
      bodyFormData.append("Others", item);
    }

    // Add POD files with "POD" attachment type
    for (const item of podUploadedFiles) {
      bodyFormData.append("POD", item);
    }

    bodyFormData.append("department", departmentName || "");
    bodyFormData.append("reconStatus", selectedRowOfDisputedEntryForModal?.reconStatus || "");
    bodyFormData.append("oldValues", JSON.stringify(oldValues));
    bodyFormData.append("newValues", JSON.stringify(newValuesData));

    await useFetch(API_ENDPOINTS.UPDATE_DR_ENTRIES_ACTION(gapId, role).url, "POST", {
      failureMessage: API_ENDPOINTS.UPDATE_DR_ENTRIES_ACTION(gapId, role).failureMessage,
      showSuccessToast: true,
      data: bodyFormData,
      thenCallBack: (_response) => {
        const updatedData = [...disputedEntriesData];
        if (selectedRowIndex !== null && selectedRowIndex !== undefined) {
          updatedData[selectedRowIndex] = {
            ...updatedData[selectedRowIndex],

            gapReason: gapReason,
            action: action,
            dependency: dependency,
            resolutionStatus: resolutionStatus,
            priority: currentPriority,
            dueDate: currentDueDate,
            maker: currentMaker.map((maker) => maker.name).join(", "),
            checker: currentChecker.map((checker) => checker.name).join(", "),
            approver: currentApprover.map((approver) => approver.name).join(", "),
          };

          setDisputedEntriesData(updatedData);
          const summaryFromData = generateSummaryFromData(updatedData);
          setSummaryData(summaryFromData);
          setIsLoadingSubmit(false);
          handleClose();
        }
      },
      catchCallBack: () => {
        setIsLoadingSubmit(false);
      },
    });
  };

  const handleCloseResolveDisputeModal = () => {
    setOpenResolveDisputeModal(false);
  };
  const handleResolveDispute = async () => {
    setLoaderResolveDispute(true);
    await useFetch(
      API_ENDPOINTS.RESOLVE_DISPUTE_DR_ENTRIES_ACTION(selectedRowOfDisputedEntryForModal?.gapId, role).url,
      "POST",
      {
        failureMessage: API_ENDPOINTS.RESOLVE_DISPUTE_DR_ENTRIES_ACTION(selectedRowOfDisputedEntryForModal?.gapId, role)
          .failureMessage,
        showSuccessToast: true,
        data: {},
        thenCallBack: (_response) => {
          const updatedData = [...disputedEntriesData];
          if (selectedRowIndex !== null && selectedRowIndex !== undefined) {
            updatedData[selectedRowIndex] = {
              ...updatedData[selectedRowIndex],
              vendorDisputeStatus: VendorDisputeStatusEnumDR.DISPUTE_RESOLVED,
            };
          }
          setDisputedEntriesData(updatedData);
          const summaryFromData = generateSummaryFromData(updatedData);
          setSummaryData(summaryFromData);
          setLoaderResolveDispute(false);
          handleCloseResolveDisputeModal();
          handleClose();
        },
        catchCallBack: () => {
          setLoaderResolveDispute(false);
          setIsLoadingSubmit(false);
        },
      }
    );
  };

  // ------------------

  return (
    <>
      <Dialog open={openTakeActionModal} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {selectedRowOfDisputedEntryForModal?.businessPartnerName || ""}
            {selectedRowOfDisputedEntryForModal?.vendorDisputeStatus === VendorDisputeStatusEnumDR.DISPUTE_RAISED ? (
              <Tooltip title={vendorRemarks} arrow>
                <Chip
                  icon={<InfoOutlined />}
                  label="Dispute raised by vendor"
                  color="error"
                  size="medium"
                  sx={{
                    "& .MuiChip-label": {
                      fontWeight: 400,
                    },
                  }}
                />
              </Tooltip>
            ) : selectedRowOfDisputedEntryForModal?.vendorDisputeStatus ===
              VendorDisputeStatusEnumDR.DISPUTE_RESOLVED ? (
              <Chip
                icon={<CheckCircleOutline />}
                label="Dispute resolved"
                color="success"
                size="medium"
                sx={{
                  "& .MuiChip-label": {
                    fontWeight: 400,
                  },
                }}
              />
            ) : null}
          </div>
          <div className="vertical_center_align">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 3 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {shouldShowGrnFields && (
              <>
                <TextField
                  className="update-custom-border-radius"
                  label="GRN Number"
                  required={
                    selectedRowOfDisputedEntryForModal?.reconStatus === "Invoice not present in Own Ledger" &&
                    selectedRowOfDisputedEntryForModal?.gapReason ===
                      "Invoice Accounted by Vendor not found in Instamart books" &&
                    action === "GRN is shared by Warehouse team"
                  }
                  placeholder="-"
                  variant="outlined"
                  fullWidth
                  value={grnNumber}
                  onChange={(e) => setGrnNumber(e.target.value)}
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "40px",
                    },
                  }}
                />

                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    className="update-custom-border-radius"
                    label="PO Number"
                    required={
                      selectedRowOfDisputedEntryForModal?.reconStatus === "Invoice not present in Own Ledger" &&
                      selectedRowOfDisputedEntryForModal?.gapReason ===
                        "Invoice Accounted by Vendor not found in Instamart books" &&
                      action === "PO Number is shared by Procurement team"
                    }
                    placeholder="-"
                    variant="outlined"
                    fullWidth
                    value={poNumber}
                    onChange={(e) => setPoNumber(e.target.value)}
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "40px",
                      },
                    }}
                  />

                  <TextField
                    className="update-custom-border-radius"
                    label="Invoice Number"
                    placeholder="-"
                    variant="outlined"
                    fullWidth
                    value={invoiceNumber}
                    onChange={(e) => setInvoiceNumber(e.target.value)}
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "40px",
                      },
                    }}
                  />
                </Box>

                {/* Upload POD Document Section */}
                <Card sx={{ border: "1px solid #d6d6d6" }}>
                  <CardContent sx={{ padding: "16px 24px" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Box>
                        <Typography className="heading-xs">Upload POD</Typography>

                        <Typography className="body-s-medium" color="textSecondary">
                          Attach your doc file here (supported formats PDF, JPG, PNG). File size limit 50MB.
                        </Typography>
                      </Box>

                      <>
                        <Input
                          type="file"
                          inputRef={(ref) => setFileInputPod(ref)}
                          sx={{ display: "none" }}
                          onChange={handlePODFileUpload}
                          inputProps={{
                            accept: ".pdf,.jpg,.png,.xlsx,.xls",
                          }}
                        />
                        <CustomButton
                          size="small"
                          colorToken="violet"
                          variant="outlined"
                          startIcon={<Upload />}
                          onClick={() => fileInputPod?.click()}
                          disabled={podUploadedFiles.length >= 5}
                        >
                          Upload
                        </CustomButton>
                      </>
                    </Box>
                  </CardContent>

                  {podUploadedFiles.map((file, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "8px 24px",
                        backgroundColor: "#f2f2f2",
                        borderTop: "1px solid #d6d6d6",
                      }}
                    >
                      <Chip
                        avatar={
                          <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                            <Description sx={{ fontSize: 14, color: "white" }} />
                          </Avatar>
                        }
                        label={
                          <Box
                            title={file.name}
                            sx={{
                              maxWidth: "250px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {file.name}
                          </Box>
                        }
                        variant="outlined"
                        sx={{
                          maxWidth: "250px",
                          borderColor: "#541c4c",
                          color: "#541c4c",
                          flex: 1,
                        }}
                      />
                      <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                        <CustomButton
                          size="small"
                          color="error"
                          variant="outlined"
                          startIcon={<Delete />}
                          onClick={() => handleDeletePOD(index)}
                        >
                          Delete
                        </CustomButton>
                      </Box>
                    </Box>
                  ))}

                  {attachmentsPOD?.length > 0 &&
                    attachmentsPOD?.map((file, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "8px 24px",
                          backgroundColor: "#f2f2f2",
                          borderTop: "1px solid #d6d6d6",
                        }}
                      >
                        <Chip
                          avatar={
                            <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                              <Description sx={{ fontSize: 14, color: "white" }} />
                            </Avatar>
                          }
                          label={
                            <Box
                              title={file.fileName}
                              sx={{
                                maxWidth: "250px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {file.fileName}
                            </Box>
                          }
                          variant="outlined"
                          sx={{
                            maxWidth: "250px",
                            borderColor: "#541c4c",
                            color: "#541c4c",
                            flex: 1, // Allow the chip to take available space
                          }}
                        />
                        <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                          <CustomButton
                            size="small"
                            colorToken="violet"
                            variant="outlined"
                            startIcon={<Visibility />}
                            onClick={() => handleViewAttachment(file)}
                          >
                            View
                          </CustomButton>
                        </Box>
                      </Box>
                    ))}
                </Card>
              </>
            )}

            {/* Upload Document Section */}
            <Card sx={{ border: "1px solid #d6d6d6" }}>
              <CardContent sx={{ padding: "16px 24px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Box>
                    <Typography className="heading-xs">Upload Document</Typography>

                    <Typography className="body-s-medium" color="textSecondary">
                      Attach your doc file here (supported formats PDF, JPG, PNG). File size limit 50MB.
                    </Typography>
                  </Box>

                  <>
                    <Input
                      type="file"
                      inputRef={(ref) => setFileInput(ref)}
                      sx={{ display: "none" }}
                      onChange={handleFileUpload}
                      inputProps={{
                        accept: ".pdf,.jpg,.png,.xlsx,.xls",
                      }}
                    />
                    <CustomButton
                      size="small"
                      colorToken="violet"
                      variant="outlined"
                      startIcon={<Upload />}
                      onClick={() => fileInput?.click()}
                      disabled={uploadedFiles.length >= 5}
                    >
                      Upload
                    </CustomButton>
                  </>
                </Box>
              </CardContent>

              {uploadedFiles.map((file, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 24px",
                    backgroundColor: "#f2f2f2",
                    borderTop: "1px solid #d6d6d6",
                  }}
                >
                  <Chip
                    avatar={
                      <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                        <Description sx={{ fontSize: 14, color: "white" }} />
                      </Avatar>
                    }
                    label={
                      <Box
                        title={file.name}
                        sx={{
                          maxWidth: "250px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {file.name}
                      </Box>
                    }
                    variant="outlined"
                    sx={{
                      maxWidth: "250px",
                      borderColor: "#541c4c",
                      color: "#541c4c",
                      flex: 1,
                    }}
                  />
                  <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                    <CustomButton
                      size="small"
                      color="error"
                      variant="outlined"
                      startIcon={<Delete />}
                      onClick={() => handleDelete(index)}
                    >
                      Delete
                    </CustomButton>
                  </Box>
                </Box>
              ))}

              {attachments?.length > 0 &&
                attachments?.map((file, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 24px",
                      backgroundColor: "#f2f2f2",
                      borderTop: "1px solid #d6d6d6",
                    }}
                  >
                    <Chip
                      avatar={
                        <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                          <Description sx={{ fontSize: 14, color: "white" }} />
                        </Avatar>
                      }
                      label={
                        <Box
                          title={file.fileName}
                          sx={{
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {file.fileName}
                        </Box>
                      }
                      variant="outlined"
                      sx={{
                        maxWidth: "250px",
                        borderColor: "#541c4c",
                        color: "#541c4c",
                        flex: 1, // Allow the chip to take available space
                      }}
                    />
                    <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                      <CustomButton
                        size="small"
                        colorToken="violet"
                        variant="outlined"
                        startIcon={<Visibility />}
                        onClick={() => handleViewAttachment(file)}
                      >
                        View
                      </CustomButton>
                    </Box>
                  </Box>
                ))}
            </Card>

            {/* Action Form Fields */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* Gap Reason */}
              <FormControl fullWidth size="small" className="update-custom-border-radius">
                <InputLabel>Gap Reason</InputLabel>
                <Select
                  value={gapReason}
                  label="Gap Reason"
                  onChange={handleGapReasonOption}
                  sx={{
                    height: "40px",
                  }}
                >
                  {gapReasonOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Action */}
              <FormControl fullWidth size="small" className="update-custom-border-radius">
                <InputLabel>Action</InputLabel>
                <Select
                  value={action}
                  label="Action"
                  onChange={handleActionOption}
                  sx={{
                    height: "40px",
                  }}
                >
                  {actionOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Dependency */}
              {/* <FormControl fullWidth size="small"  className="update-custom-border-radius">
                <InputLabel>Dependency</InputLabel>
                <Select
                  value={dependency}
                  label="Dependency"
                  onChange={(e) => setDependency(e.target.value)}
                  sx={{
                    height: '40px'
                  }}
                >
                  {dependencyOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
              <TextField
                className="update-custom-border-radius"
                label="Dependency"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={dependency}
                onChange={(e) => setDependency(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled
              />
              {/* Resolution Status */}
              {/* <FormControl fullWidth size="small"  className="update-custom-border-radius">
                <InputLabel>Resolution Status</InputLabel>
                <Select
                  value={resolutionStatus}
                  label="Resolution Status"
                  onChange={(e) => setResolutionStatus(e.target.value)}
                  sx={{
                    height: '40px'
                  }}
                >
                  {resolutionStatusOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
              <TextField
                className="update-custom-border-radius"
                label="Resolution Status"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={resolutionStatus}
                onChange={(e) => setResolutionStatus(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled
              />

              <TextField
                className="update-custom-border-radius"
                label="Vendor Remarks"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={vendorRemarks}
                onChange={(e) => setVendorRemarks(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={departmentName === DepartmentType.Vendor ? false : true}
              />
              <TextField
                className="update-custom-border-radius"
                label="Finance Remarks"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={financeRemarks}
                onChange={(e) => setFinanceRemarks(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={departmentName === DepartmentType.Finance ? false : true}
              />
              <TextField
                className="update-custom-border-radius"
                label="Warehouse Remarks"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={warehouseRemarks}
                onChange={(e) => setWarehouseRemarks(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={departmentName === DepartmentType.Warehouse ? false : true}
              />
              <TextField
                className="update-custom-border-radius"
                label="Procurement Remark"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={procurementRemark}
                onChange={(e) => setProcurementRemark(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={departmentName === DepartmentType.Procurement ? false : true}
              />

              <TextField
                className="update-custom-border-radius"
                label="AR/ BTPL Remark"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={arBtplRemark}
                onChange={(e) => setArBtplRemark(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={
                  departmentName === DepartmentType.ARTeam || departmentName === DepartmentType.BTPL ? false : true
                }
              />
              <TextField
                className="update-custom-border-radius"
                label="Category Remark"
                placeholder="-"
                variant="outlined"
                fullWidth
                value={categoryRemark}
                onChange={(e) => setCategoryRemark(e.target.value)}
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                  },
                }}
                disabled={departmentName === DepartmentType.Category ? false : true}
              />

              <Autocomplete
                multiple
                size="small"
                value={currentMaker}
                onChange={(_, newValue) => {
                  setCurrentMaker(newValue);
                }}
                sx={{ width: "100%", "& fieldset": { borderRadius: "4px" } }}
                disableClearable
                options={allUsers} // Show all users
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderOption={(props, item) => (
                  <li {...props} key={item.id}>
                    <ListItemText>{item.name}</ListItemText>
                  </li>
                )}
                getOptionLabel={(option: { name: string; id: number }) => option.name}
                renderInput={(params) => <TextField {...params} label="Maker" size="small" />}
              />
              {(actor.userRole === UserRole.DRApprover ||
                actor.userRole === UserRole.DRChecker ||
                actor.userRole === UserRole.ReconDRApprover) && (
                <Autocomplete
                  multiple
                  size="small"
                  value={currentChecker}
                  onChange={(_, newValue) => {
                    setCurrentChecker(newValue);
                  }}
                  sx={{ width: "100%", "& fieldset": { borderRadius: "4px" } }}
                  disableClearable
                  options={allUsers?.filter(
                    (user) =>
                      user.role === UserRole.DRChecker ||
                      user.role === UserRole.DRApprover ||
                      user.role === UserRole.ReconDRApprover
                  )} // Filter users by role
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderOption={(props, item) => (
                    <li {...props} key={item.id}>
                      <ListItemText>{item.name}</ListItemText>
                    </li>
                  )}
                  getOptionLabel={(option: { name: string; id: number }) => option.name}
                  renderInput={(params) => <TextField {...params} label="Checker" size="small" />}
                />
              )}

              {(actor.userRole === UserRole.DRApprover || actor.userRole === UserRole.ReconDRApprover) && (
                <Autocomplete
                  multiple
                  size="small"
                  value={currentApprover}
                  onChange={(_, newValue) => {
                    setCurrentApprover(newValue);
                  }}
                  sx={{ width: "100%", "& fieldset": { borderRadius: "4px" } }}
                  disableClearable
                  options={allUsers?.filter(
                    (user) => user.role === UserRole.DRApprover || user.role === UserRole.ReconDRApprover
                  )} // Filter users by role
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderOption={(props, item) => (
                    <li {...props} key={item.id}>
                      <ListItemText>{item.name}</ListItemText>
                    </li>
                  )}
                  getOptionLabel={(option: { name: string; id: number }) => option.name}
                  renderInput={(params) => <TextField {...params} label="Approver" size="small" />}
                />
              )}
              <Autocomplete
                value={currentPriority}
                onChange={(_, newValue) => {
                  setCurrentPriority(newValue);
                }}
                sx={{ width: "100%", "& fieldset": { borderRadius: "4px" } }}
                disableClearable
                options={["High", "Medium", "Low"]}
                renderOption={(props, item) => (
                  <li {...props} key={item}>
                    <ListItemText>{item}</ListItemText>
                  </li>
                )}
                // disabled={actor.userRole === UserRole.ReconDRApprover ? false : true}
                disabled
                renderInput={(params) => <TextField {...params} label="Priority" size="small" />}
              />
              <TextField
                type="date"
                InputProps={{
                  style: {
                    borderRadius: "4px",
                  },
                }}
                value={currentDueDate}
                sx={{ width: "100%" }}
                size="small"
                label="Due Date"
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                  setCurrentDueDate(e.target.value);
                }}
                disabled={actor.userRole === UserRole.ReconDRApprover ? false : true}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          className="dialog-actions"
          sx={{
            justifyContent:
              selectedRowOfDisputedEntryForModal?.vendorDisputeStatus === VendorDisputeStatusEnumDR.DISPUTE_RAISED
                ? "space-between"
                : "flex-end",
          }}
        >
          {selectedRowOfDisputedEntryForModal?.vendorDisputeStatus === VendorDisputeStatusEnumDR.DISPUTE_RAISED && (
            <CustomButton
              size="medium"
              color="info"
              variant="outlined"
              onClick={() => setOpenResolveDisputeModal(true)}
              startIcon={<CheckCircleOutline />}
            >
              Resolve Dispute
            </CustomButton>
          )}
          <Box sx={{ display: "flex", gap: 1 }}>
            <CustomButton size="medium" colorToken="violet" variant="outlined" onClick={handleClose}>
              Cancel
            </CustomButton>
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="contained"
              disabled={
                isLoadingSubmit ||
                (shouldShowGrnFields &&
                  selectedRowOfDisputedEntryForModal?.reconStatus === "Invoice not present in Own Ledger" &&
                  selectedRowOfDisputedEntryForModal?.gapReason ===
                    "Invoice Accounted by Vendor not found in Instamart books" &&
                  action === "GRN is shared by Warehouse team" &&
                  !grnNumber.trim()) ||
                (shouldShowGrnFields &&
                  selectedRowOfDisputedEntryForModal?.reconStatus === "Invoice not present in Own Ledger" &&
                  selectedRowOfDisputedEntryForModal?.gapReason ===
                    "Invoice Accounted by Vendor not found in Instamart books" &&
                  action === "PO Number is shared by Procurement team" &&
                  !poNumber.trim())
              }
              startIcon={<LoadingIcon loading={isLoadingSubmit} />}
              onClick={handleSubmit}
            >
              Update
            </CustomButton>
          </Box>
        </DialogActions>
      </Dialog>

      {openResolveDisputeModal && (
        <Dialog open={openResolveDisputeModal} maxWidth={DIALOG_MAX_WIDTHS.XS} fullWidth>
          <DialogTitle className="dialog-title">
            <div className="heading-m" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              Are you sure?
            </div>
            <div className="vertical_center_align">
              <IconButton onClick={handleCloseResolveDisputeModal}>
                <Close />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 3 }}>
            <Alert severity="info">
              This will close dispute on your end. It will be notified to vendor for further review.
            </Alert>
          </DialogContent>
          <DialogActions className="dialog-actions">
            <CustomButton size="medium" colorToken="violet" variant="text" onClick={handleCloseResolveDisputeModal}>
              Cancel
            </CustomButton>
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="contained"
              onClick={handleResolveDispute}
              startIcon={<LoadingIcon loading={loaderResolveDispute} />}
              disabled={loaderResolveDispute}
            >
              Resolve Dispute
            </CustomButton>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default TakeActionDisputedEntries;
